export const P0003606ConsigneRegulationPh = [
  { label: '6.8', ref: 68 },
  { label: '6.9', ref: 69 },
  { label: '7', ref: 70 },
  { label: '7.1', ref: 71 },
  { label: '7.2', ref: 72 },
  { label: '7.3', ref: 73 },
  { label: '7.4', ref: 74 },
  { label: '7.5', ref: 75 },
  { label: '7.6', ref: 76 },
  { label: '7.7', ref: 77 },
  { label: '7.8', ref: 78 },
];
